import styled, { css } from 'styled-components';

interface ContainerProps {
  collapse: boolean;
}

interface ResultsGridProps {
  resultsNum: number;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  min-height: 0vh;

  ${(props) =>
    !props.collapse &&
    css`
      min-height: 40vh;

      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export const ResultsList = styled.div<ResultsGridProps>`
  width: 100%;

  display: flex;
  justify-content: center;
  flex-flow: row wrap;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin: 5px;

    color: #999;
    font-size: 22px;
  }

  @media only screen and (max-width: 900px) {
    padding: 20px;
    text-align: center;
  }
`;
